// modules/Battle/BattleUIInput.js
// 战斗UI输入处理模块

import InputHelper from '../InputHelper.js';

export default class BattleUIInput {
    constructor(scene, menu, targetSelection, events) {
        this.scene = scene;
        this.menu = menu;
        this.targetSelection = targetSelection;
        this.events = events;
        this.menuInput = null;
    }
    
    /**
     * 设置输入处理
     */
    setupInput() {
        this.menuInput = InputHelper.bindMenuKeyboard(this.scene, {
            blockWhen: () => {
                if (this.scene.battleState.isAnimating) return true;
                if (this.scene.battleState.phase === 'waitingForTeamMember') return true;
                if (this.scene.battleUI && !this.scene.battleUI.isInteractive()) return true;
                return false;
            },
            onUp: () => this._handleDirection('up'),
            onDown: () => this._handleDirection('down'),
            onLeft: () => this._handleDirection('left'),
            onRight: () => this._handleDirection('right'),
            onSelect: () => this._handleSelect(),
            onCancel: () => this._handleCancel()
        }, { horizontal: true });
    }

    destroyInput() {
        if (this.menuInput) {
            this.menuInput.destroy();
            this.menuInput = null;
        }
    }

    _handleDirection(direction) {
        if (this.menu.selectingWeapon) {
            if (direction === 'up') this.menu.moveWeaponSelection(-1);
            if (direction === 'down') this.menu.moveWeaponSelection(1);
            return;
        }
        if (this.menu.selectingItem) {
            if (direction === 'up') this.menu.moveItemSelection(-1);
            if (direction === 'down') this.menu.moveItemSelection(1);
            return;
        }
        if (this.menu.selectingSkill) {
            if (direction === 'up') this.menu.moveSkillSelection(-1);
            if (direction === 'down') this.menu.moveSkillSelection(1);
            return;
        }
        if (this.targetSelection.selectingTarget || this.targetSelection.selectingRangeTarget) {
            if (direction === 'up') this.targetSelection.moveTargetSelection(-1);
            if (direction === 'down') this.targetSelection.moveTargetSelection(1);
            return;
        }
        if (direction === 'left') this.menu.moveSelection(-1);
        if (direction === 'right') this.menu.moveSelection(1);
    }

    _handleSelect() {
        if (this.menu.selectingWeapon) {
            const selectedWeapon = this.menu.getSelectedWeapon();
            if (selectedWeapon) {
                this.events.emit('weaponSelected', selectedWeapon, this.menu.selectedWeaponIndex, this.menu.weaponType);
            }
            return;
        }
        if (this.menu.selectingItem) {
            const selectedItem = this.menu.getSelectedItem();
            if (selectedItem) {
                this.events.emit('itemSelected', selectedItem, this.menu.selectedItemIndex);
            }
            return;
        }
        if (this.menu.selectingSkill) {
            const selectedSkill = this.menu.getSelectedSkill();
            if (selectedSkill) {
                this.events.emit('skillSelected', selectedSkill, this.menu.selectedSkillIndex);
            }
            return;
        }
        if (this.targetSelection.selectingTarget || this.targetSelection.selectingRangeTarget) {
            const result = this.targetSelection.confirmTargetSelection();
            if (result) {
                this.events.emit('targetSelected', result.targetIndex, result.isRangeAttack);
                this.targetSelection.clearTargetSelection();
            }
            return;
        }
        this.events.emit('actionSelected', this.menu.getSelectedOption());
    }

    _handleCancel() {
        if (this.menu.selectingWeapon) {
            this.menu.selectingWeapon = false;
            this.menu.hideWeaponMenu();
            this.events.emit('cancelWeaponSelection');
            return;
        }
        if (this.menu.selectingItem) {
            this.menu.selectingItem = false;
            this.menu.hideItemMenu();
            this.events.emit('cancelItemSelection');
            return;
        }
        if (this.menu.selectingSkill) {
            this.menu.selectingSkill = false;
            this.menu.hideSkillMenu();
            this.events.emit('cancelSkillSelection');
            return;
        }
        if (this.targetSelection.selectingTarget || this.targetSelection.selectingRangeTarget) {
            this.targetSelection.clearTargetSelection();
            this.events.emit('cancelTargetSelection');
            return;
        }
        this.events.emit('cancelAction');
    }
}
